export function addGtagPixel(pixelId) {
	const head = document.head || document.getElementsByTagName('head')[0];
	if (!head) {
		console.error('No head element found in the document.');
		return;
	}

	const scriptGoogleTagLink = document.createElement('script');
	scriptGoogleTagLink.async = true;
	scriptGoogleTagLink.src = `https://www.googletagmanager.com/gtag/js?id=${pixelId}`;
	head.appendChild(scriptGoogleTagLink);

	const scriptGoogleTagAws = document.createElement('script');
	scriptGoogleTagAws.textContent = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${pixelId}');`;
	head.appendChild(scriptGoogleTagAws);
}

export function sendAddToCartEvent(viajeId, viajeName, currency, price) {
	if (typeof window.gtag !== 'undefined') {
		window.gtag('event', 'add_to_cart', {
			items: [
				{
					itemId: viajeId,
					itemName: viajeName,
				}
			],
			currency: currency,
			value: price,
		});
	}
}

export function sendBeginCheckoutEvent(viajeId, numReservas, currency, price) {
	if (typeof window.gtag !== 'undefined') {
		window.gtag('event', 'begin_checkout', {
			items: [
				{
					itemId: viajeId,
					quantity: numReservas
				}
			],
			currency: currency,
			value: price,
		});
	}
}

export function sendPurchaseEvent(viajeId, numReservas, grupoReservasId, currency, price) {
	if (typeof window.gtag !== 'undefined') {
		window.gtag('event', 'purchase', {
			items: [
				{
					itemId: viajeId,
					quantity: numReservas
				}
			],
			transaction_id: grupoReservasId,
			currency: currency,
			value: price,
		});
	}
}

export function sendViewItemEvent(viajeId, currency, price) {
	if (typeof window.gtag !== 'undefined') {
		window.gtag('event', 'view_item', {
			items: [
				{
					itemId: viajeId
				}
			],
			currency: currency,
			value: price,
		});
	}
}

export default {
	sendAddToCartEvent,
	sendBeginCheckoutEvent,
	sendPurchaseEvent,
	sendViewItemEvent,
}